"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TaskRecorder_Cancel: "Cancel",
            TaskRecorder_Continue: "Continue",
            TaskRecorder_OpenPane: "Task recorder",
            TaskRecorder_Start: "Start",
            TaskRecorder_Stop: "Stop",
        }
    });
    var ax;
    (function (ax) {
        /** Hosts the SysTaskRecorderPane X++ form in the Task Recorder pane. */
        var TaskRecorderPane = /** @class */ (function () {
            function TaskRecorderPane() {
                this.canAddValidation = $dyn.computed(function () {
                    return $dyn.serverForm.interactionManager && $dyn.serverForm.interactionManager.getRootFormId && $dyn.serverForm.interactionManager.getRootFormId() != null;
                });
                this.VisiblePane = $dyn.observable(true);
            }
            TaskRecorderPane.prototype.close = function () {
                if (!$dyn.value($dyn.ax.taskRecording.started)) {
                    $dyn.ax.taskRecording.pane = null;
                }
                $dyn.ax.taskRecording.close();
            };
            return TaskRecorderPane;
        }());
        ax.TaskRecorderPane = TaskRecorderPane;
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TaskRecorderPane.js.map
